import React from "react";
import { Typography } from "antd";
import DefaultParagraph from "./components/DefaultParagraph";
import { Bold, DefaultTitle } from "./components/ParagraphElement";
import { useHistory } from "react-router-dom";
const { Title } = Typography;

const TermsEnglish = () => {
  const history = useHistory();
  return (
    <div
      style={{
        margin: "20px auto",
        padding: 10,
      }}
    >
      <Title level={3} style={{ textAlign: "center" }}>
        Terms and Conditions
      </Title>
      <div className="w-max m-auto mb-6">
        <DefaultParagraph>
          These terms and conditions ("<Bold>Terms</Bold>") have been prepared
          for the charging service at Service Stations provided by{" "}
          <Bold>ARUN PLUS Solutions Company Limited ("ARUN PLUS")</Bold>, whose
          head office is located at 555/1 Energy Complex, Building A, Vibhavadi
          Rangsit Road, Chatuchak, Bangkok, 10900, for users of Electric
          Vehicles ("
          <Bold>User</Bold>"), the content of which is as follows:{" "}
        </DefaultParagraph>

        <DefaultTitle>1.Important Message </DefaultTitle>
        <DefaultParagraph leader="1.1.">
          <Bold>
          The User must thoroughly read and understand the Terms 
          and our data privacy policies in order to comprehend the rights and obligations 
          between the User and ARUN PLUS and for the User's own safety. 
          The User hereby accepts the Terms and the aforementioned 
          data privacy policy prior to the User's account registration 
          and use of ARUN PLUS's Service through the Application.
          </Bold>
        </DefaultParagraph>
        <DefaultParagraph leader="1.2.">
          <Bold>
          ARUN PLUS reserves the right to partly or wholly amend or annul the Terms 
          or the data privacy policies. In the event of an amendment or annulment, 
          ARUN PLUS will provide the User with a notification about such amendment or 
          annulment through the Application. The User must accept such amended or 
          annulled Terms and/or data privacy policy prior to using ARUN PLUS's Service through the Application. 
          </Bold>
        </DefaultParagraph>
        <DefaultParagraph leader="1.3.">
          <Bold>
          ARUN PLUS may from time to time provide specific terms for the purpose of providing 
          certain types of service. Such specific terms shall be deemed to be a part of the Terms 
          and the User shall read, understand, and accept such Terms prior to using such service. 
          In the event that the specific terms conflict with this Terms, this Terms shall prevail. 
          </Bold>
        </DefaultParagraph>

        <DefaultTitle>2.Definitions</DefaultTitle>
        <DefaultParagraph>
          Unless it is specified otherwise, the words used in these Terms shall
          have the meanings provided in this Clause.
        </DefaultParagraph>
        <DefaultParagraph leader="2.1.">
          <Bold>“Information”</Bold> means textual or factual content, whether expressed 
          in words, numbers, sound, image, or any other format, which may convey meaning, 
          and includes electronic Information that is electronically created, sent, received, 
          stored, or processed.
        </DefaultParagraph>
        <DefaultParagraph leader="2.2.">
          <Bold>“EV Charger”</Bold> means a charger used to charge Electric
          Vehicles, and includes equipment used to connect with the EV Charger
          such as electric wires, circuit breakers, and conduits, among others,
          that belong to ARUN PLUS .
        </DefaultParagraph>
        <DefaultParagraph leader="2.3.">
          <Bold>“Area Provider”</Bold> means a person with the ownership, 
          possessory right, or the right to use an area, who gives ARUN PLUS 
          the right to use such area for the purpose of establishing a Service Station. 
        </DefaultParagraph>
        <DefaultParagraph leader="2.4.">
          <Bold>“Service”</Bold> means the use of a Service Station to charge an 
          Electric Vehicle, using an EV Charger, through the use of the Application. 
        </DefaultParagraph>
        <DefaultParagraph leader="2.5.">
          <Bold>“Electric Vehicle”</Bold> means vehicles that are Battery Electric Vehicle (BEV) 
          and Plug-In Hybrid Electric Vehicle (PHEV), of two (2) and four (4) wheels, 
          which can accommodate charging through an EV Charger as determined by ARUN PLUS, 
          as well as other vehicles as stipulated by ARUN PLUS. 
        </DefaultParagraph>
        <DefaultParagraph leader="2.6.">
          <Bold>“Service Station”</Bold> means a charging station for Electric Vehicles, 
          which comprises of an EV Charger and a parking space for Electric Vehicles for 
          Users during the charging process.
        </DefaultParagraph>
        <DefaultParagraph leader="2.7.">
          <Bold>“Application”</Bold> means ARUN PLUS's application on electronic communication devices.
        </DefaultParagraph>

        <DefaultTitle>3.Service Account Registration</DefaultTitle>
        <DefaultParagraph leader="3.1.">
        The registrant must hold a legal and valid driver's license. 
        In the absence of a driver's license, in order to use our Services, 
        such registrant must be of the age of majority (sui juris) and 
        direct a person with a legal and valid driver's license to drive 
        the Electric Vehicle to and from the Service Station.
        </DefaultParagraph>
        <DefaultParagraph leader="3.2.">
        To use the Service for the first time, the User must open an account 
        through the Application by providing Information such as the 
        registrant's email, password, telephone number, credit card number and 
        its expiry date, and other details as required by ARUN PLUS. 
        The User may register by connecting the User's account with the User's Apple, 
        Facebook, or Google account. To this end, the User confirms that 
        the Information provided for the registration process is true, accurate, 
        and complete, and the User has a duty to constantly update such Information 
        or the User may be denied Service.
        </DefaultParagraph>

        <DefaultTitle>
          4.Rights and Obligations When Using the Service
        </DefaultTitle>
        <DefaultParagraph style={{ paddingLeft: 10 }} nostartspace underline>
          Electric Vehicle and Charging
        </DefaultParagraph>
        <DefaultParagraph leader="4.1.">
        The User must only use the Service Station, EV Charger, parking area, 
        and Application for the purpose of charging the Electric Vehicle 
        and not in any illegal manner or in any way which conflicts with the 
        Terms or guidelines ordinarily used for Service Stations.
        </DefaultParagraph>
        <DefaultParagraph leader="4.2.">
        The User must study the use of the EV Charger and comply with the 
        guideline on how to use the EV Charger, as well as the charging 
        guideline provided by the Electric Vehicle's manufacturer. 
        The User must comply with the suggestions and use instructions on the Application, 
        at the Service Station, and at the EV Charger (if any).
        </DefaultParagraph>
        <DefaultParagraph leader="4.3.">
        The User confirms that the Electric Vehicle used to receive 
        the charging Service complies with the specifications stipulated by ARUN PLUS.
        </DefaultParagraph>
        <DefaultParagraph leader="4.4.">
        The User confirms that the User is the owner or has the right to possess 
        the Electric Vehicle under the applicable law, that the Electric Vehicle 
        being charged is in a good condition, and that the Electric Vehicle uses 
        the charging system and equipment made by the Electric Vehicle's manufacturer.
        </DefaultParagraph>
        <DefaultParagraph leader="4.5.">
        The User must use the EV Charger with care and consideration for the lives 
        and properties of both the User and of others. 
        </DefaultParagraph>
        <DefaultParagraph leader="4.5." hideleader>
        If the EV Charger experiences malfunction, is damaged, or if any 
        abnormality is discovered before, during, or after the charging process, 
        or if another person, the EV Charger, vehicles, or other properties 
        within the Service Station or the area within the vicinity thereof 
        suffers loss or is in danger, the User must immediately report such 
        incident to ARUN PLUS service center or report such incident through the Application.
        </DefaultParagraph>
        <DefaultParagraph leader="4.6.">
        The User must comply with the conditions of the Area Provider, 
        and must not park the Electric Vehicle or place any object in 
        a manner which obstructs or disturbs the use of the Service 
        by other Users or the traffic.
        </DefaultParagraph>
        <DefaultParagraph leader="4.7.">
        The User acknowledges that Service Stations are not a vehicle 
        storage service for Electric Vehicles and that ARUN PLUS shall 
        not held liable for any loss or damage that the Electric Vehicle 
        incurs during the time that it is parked in a Service Station.
        </DefaultParagraph>
        <DefaultParagraph style={{ paddingLeft: 10 }} nostartspace underline>
          Scheduling
        </DefaultParagraph>
        <DefaultParagraph leader="4.8.">
        The User may schedule a time slot to use an EV Charger through 
        the Application not more than one (1) day in advance. 
        </DefaultParagraph>
        <DefaultParagraph leader="4.9.">
        If the User wishes to cancel a time slot prior to the scheduled time, 
        the User must cancel the time slot through the Application by the time 
        specified by ARUN PLUS and by following ARUN PLUS's instruction.
        </DefaultParagraph>
        <DefaultParagraph leader="4.9." hideleader>
        If the User does not check into the Service Station within the time 
        stipulated by ARUN PLUS, ARUN PLUS has the right to cancel the scheduled time 
        slot without any prior consent from the User. ARUN PLUS reserves the right 
        to charge the User for the cancellation fine incurred by the User at 
        the rate determined by ARUN PLUS.
        </DefaultParagraph>
        <DefaultParagraph style={{ paddingLeft: 10 }} nostartspace underline>
          Checking In
        </DefaultParagraph>
        <DefaultParagraph leader="4.10.">
          The User must bring the Electric Vehicle to park at the Service Station at the location provided 
          for Electric Vehicles and check into the Application immediately upon parking and before charging the Electric Vehicle.
        </DefaultParagraph>
        <DefaultParagraph style={{ paddingLeft: 10 }} nostartspace underline>
          Checking Out
        </DefaultParagraph>
        <DefaultParagraph leader="4.11.">
        The User must pay and check out of the application and remove the Electric Vehicle 
        from the area within the Service Station within the time slot scheduled for each charging session.
        </DefaultParagraph>
        <DefaultParagraph leader="4.11." hideleader>
        Where a scheduled time slot ends without being renewed or if no further Service 
        scheduling is made and the User does not check out or does and remove the 
        Electric Vehicle from the Service Station, ARUN PLUS reserves the right to 
        impose fine at the rate specified by ARUN PLUS and ARUN PLUS has the right to 
        take any action to remove the Electric Vehicle from the Service Station area. 
        In such event, the User shall be liable for any expense incurred from such action (if any). 
        </DefaultParagraph>
        <DefaultParagraph style={{ paddingLeft: 10 }} nostartspace underline>
          Ownership and Use
        </DefaultParagraph>
        <DefaultParagraph leader="4.12.">
        4.12.	The User acknowledges that the EV Chargers are under the ownership of ARUN PLUS, 
        and that the User only has the right to use the EV Chargers during the scheduled time 
        slot and only for the purpose(s) provided in the Terms. The User must not change, repair, 
        connect, or remove any equipment of the EV Charger on their own.
        </DefaultParagraph>

        <DefaultTitle>
          5.Rights and Obligations in the Use of the Application
        </DefaultTitle>
        <DefaultParagraph leader="5.1.">
        5.1.	Each account is for personal use only. The User must keep confidential 
        the username and password of the account and must not allow others to 
        use the account. If the User allows others to use the account, the User, 
        who is the owner of the account, will be held liable for all expenses 
        incurred and damage that ARUN PLUS suffers from the use of the account 
        by such person. 
        </DefaultParagraph>
        <DefaultParagraph leader="5.1." hideleader>
        If the User discovers any use of the Application which does not originate from the User, 
        the User must immediately report such use to ARUN PLUS.
        </DefaultParagraph>
        <DefaultParagraph leader="5.2.">
        5.2.	The User acknowledges that the Information, Application, artificial intelligence technology, 
        technicality, know-how, electronic system, intellectual properties, 
        and other rights that are used in providing the Service under the Terms belong 
        to ARUN PLUS. The User agrees that the User shall not undertake any action that
         may infringe the rights or intellectual properties of ARUN PLUS. 
        </DefaultParagraph>
        <DefaultParagraph leader="5.3.">
        The User shall not use or attempt to use a Service Station through any other means, including the through automated process 
        such as the use of scripting (a series of commands or programming language is embedded into the member system), 
        other than the process specified by ARUN PLUS, unless the User has received a written prior permission from ARUN PLUS. 
        </DefaultParagraph>
        <DefaultParagraph leader="5.4.">
        The User shall not take part in obstructing or disturbing the use of the Application, 
        including accessing the database, or changing or taking any action on the server or the network 
        that is connected to the use of the Application. 
        </DefaultParagraph>
        <DefaultParagraph leader="5.5.">
        The User may delete the account at any time. In the event that the User does not use 
        the account for more than one (1) year from the date of the account's last use, 
        ARUN PLUS reserves the right to delete the account from the system without prior notification to the User. 
        </DefaultParagraph>
        <DefaultParagraph leader="5.6.">
        In using the Service and in taking any action on the Application, 
        it shall be deemed that such action is enforceable, complete, and binding 
        upon the User and that such action is duly executed and enforceable under 
        the law, and that action is considered as valid evidence of such electronic transaction, 
        and may be used as the original copy in a legal proceeding without 
        ARUN PLUS having to verify the accuracy thereof or the authority or identity 
        of the User and without the User having to sign any document unless 
        explicitly required otherwise. 
        </DefaultParagraph>
        <DefaultParagraph leader="5.7.">
        The User must give ARUN PLUS the right to access the location of the User's mobile phone 
        on which the Application is installed if the User wishes to receive 
        suggestions of the locations of Service Stations.
        </DefaultParagraph>
        <DefaultParagraph leader="5.8.">
        5.8.	Any links to other websites are only provided for the purpose of facilitating the User's experience. 
        ARUN PLUS is not involved in such websites and does not have any authority to 
        control or guarantee the accuracy or credibility thereof.
        </DefaultParagraph>
        <DefaultParagraph leader="5.8." hideleader>
        ARUN PLUS is not liable for any content displayed on other websites which are linked to ARUN PLUS's website 
        nor is ARUN PLUS responsible for any damage or loss incurred due to a visit to such websites.
        </DefaultParagraph>

        <DefaultTitle>6.Rights and Responsibilities of ARUN PLUS </DefaultTitle>
        <DefaultParagraph leader="6.1.">
        ARUN PLUS provides charging Service Stations for Electric Vehicles. 
        Users may use the Application to find the location of a Service Station 
        in order to schedule a time slot to use an EV Charger, choose the time to use an EV Charger, 
        determine the charging time, connect the EV Charger to the 
        charging system of the User's Electric Vehicle, and pay for Service fees and fines (if any). 
        To this end, ARUN PLUS's EV Chargers can only charge Electric Vehicles of the specifications determined by ARUN PLUS. 
        </DefaultParagraph>
        <DefaultParagraph leader="6.2.">
        The Service session of each Service Station shall be in accordance with the terms and conditions of each respective Area Provider. 
        </DefaultParagraph>
        <DefaultParagraph leader="6.3.">
        ARUN PLUS will exercise its reasonable endeavor to enable Users to enjoy the ordinary functioning 
        of the Service Stations. However, for the Users' safety or a delay in the use of the Service caused 
        by the preceding User(s), the Service may be delayed or suspended due to a technical difficulty in electrical 
        distribution on the part of the respective electricity authority or the Area Provider, 
        troubleshooting of the Application, malfunctioning of the internet or the mobile phone signal coverage, 
        issues with the EV Charger, or any other causes. In such event, it shall not be considered that ARUN PLUS 
        has committed any breach of any obligation under the Terms and shall not be liable for any loss. 
        </DefaultParagraph>
        <DefaultParagraph leader="6.4.">
        ARUN PLUS has installed an electricity voltage measurement system at the EV Charger 
        and the system will demonstrate the electricity unit measurement Information on the screen 
        of the mobile phone that the User has designated on the Application. 
        </DefaultParagraph>
        <DefaultParagraph leader="6.5.">
        ARUN PLUS has the right to collect and process User's Information for the purpose of identifying its members. 
        </DefaultParagraph>
        <DefaultParagraph leader="6.6.">
        ARUN PLUS has the right to cease providing the Service or to deny access to a part of or the entire Service 
        at any time and for whatever reason, without having to provide the User with a prior notice.


        </DefaultParagraph>
        <DefaultParagraph leader="6.6." hideleader>
        ARUN PLUS has the right to change or improve the Service, whether in whole or in part, 
        at ARUN PLUS's sole discretion without having to provide the User any prior notice.  
        </DefaultParagraph>

        <DefaultTitle>7.Payment </DefaultTitle>
        <DefaultParagraph leader="7.1.">
        The User must pay the amount indicated on the Application. 
        The Service fee rate at each Service Station may differ depending on the 
        location of the Service Station or the size of the EV Charger. The format 
        and instruction for the payment shall be as determined by ARUN PLUS. 
        ARUN PLUS reserves right to change Service Fee rate without prior notice.
        </DefaultParagraph>
        <DefaultParagraph leader="7.2.">
        In the event that the Service fee exceeds the amount displayed on the Application 
        before the Service, the User agrees to pay ARUN PLUS for the exceeding amount and any fine incurred. 
        </DefaultParagraph>
        <DefaultParagraph leader="7.3.">
        7.3.	In the event that the payment is made from a credit card, 
        the User acknowledges that each time that the Service is used, 
        a payment pre-authorization from the User's credit card will be necessary. 
        The User agrees to allow ARUN PLUS to pre-authorize the payment 
        each time prior to using the Service. Such pre-authorization 
        does not constitute a payment for the Service Fee or a payment made 
        from the credit card and shall be in accordance with 
        ARUN PLUS's Service policies and procedure. 
        </DefaultParagraph>
        <DefaultParagraph leader="7.3." hideleader>
        The payment will be made from the credit card's balance during the checkout process. 
        If the actual amount of Service fee owed is less than the pre-authorized amount, 
        the User will receive the difference within the operation hours of the card issuer bank. 
        In regular circumstances, if the time has been scheduled and the Service finishes before 21:00 (9:00 pm), 
        the User will receive the difference back within the day of the Service. 
        If the time has been scheduled and the Service finishes after 21:00 (9:00 pm), 
        you will receive the difference back within seven (7) to fourteen (14) business days, 
        depending on the card issuing bank. 
        </DefaultParagraph>
        <DefaultParagraph leader="7.4.">
        In the event that ARUN PLUS is unable to obtain payment 
        pre-authorization due to the fact that the credit limit would be exceeded, 
        the User will be unable to receive any Service from the Service Station.
        </DefaultParagraph>

        <DefaultTitle>8.Limitation of Liability</DefaultTitle>
        <DefaultParagraph leader="8.1">
        ARUN PLUS shall not be responsible for any loss or damage incurred upon the 
        User's Electric Vehicle or property from the use of the Service, 
        whether by the User or by any other person unless such loss or damage is 
        caused by a deliberate action or gross negligence by ARUN PLUS. In such case, 
        ARUN PLUS agrees to be liable only for loss or damage directly incurred by the User, 
        which must be provable, and shall not be liable for any incidental loss or for damage 
        arising from special circumstances. 
        </DefaultParagraph>
        <DefaultParagraph leader="8.2">
        The User shall be liable for any loss or damage, as well as any expense incurred 
        by ARUN PLUS which is caused by the User's non-compliance with the Terms or which 
        arises from any claim by a third party to which ARUN PLUS is liable. 
        </DefaultParagraph>

        <DefaultTitle>
          9. Handling of Personal Data and Confidential Information 
        </DefaultTitle>
        <DefaultParagraph leader="9.1.">
        Store, use, and disclose personal data of Users.
        </DefaultParagraph>
        <DefaultParagraph leader="9.1.1" style={{ margin: "auto auto 1em 20px" ,maxWidth: 780 }}>
        Store and use Users’s name, surname, usage history and contacts for evaluating, 
        improving and developing ARUN PLUS’s products, services and marketing activities.
        </DefaultParagraph>
        <DefaultParagraph leader="9.1.2" style={{ margin: "auto auto 1em 20px" ,maxWidth: 780 }}>
        Store and use Users’s name, surname, usage history and contacts for analyzing, 
        researching and developing ARUN PLUS’s products and services to respond customer needs.
        </DefaultParagraph>
        <DefaultParagraph leader="9.1.3" style={{ margin: "auto auto 1em 20px" ,maxWidth: 780 }}>
        Store and use Users’s name, surname and contacts for informing news, promotions, 
        activities invitation of ARUN PLUS products and service through E-mails, SMSs and phone calls.
        </DefaultParagraph>
        <DefaultParagraph leader="9.1.4" style={{ margin: "auto auto 1em 20px" ,maxWidth: 780 }}>
        Disclose Users’s name, surname and contacts to subsidiaries, 
        affiliated companies and any related companies for operating businesses, 
        payment and accounting activities, and management.
        </DefaultParagraph>
        <DefaultParagraph leader="9.2.">
        If there is any personal information that Users would like us to erase, 
        please send the request through email: onionevcharger@gmail.com
        </DefaultParagraph>

        <DefaultParagraph >
        Please refer to <span style={{ color: '#2F80ED',fontWeight:'bold' }} className='hover:opacity-80 cursor-pointer' onClick={() => {
            history.push('/privacy-polices?languages=eng')
          }}>Privacy Policy</span> for more detail.
        </DefaultParagraph>

        <DefaultTitle>10.Relationship between ARUN PLUS and User</DefaultTitle>
        <DefaultParagraph>
        The terms and conditions under the Terms do not create any employment, 
        agency, or representative relationship between ARUN PLUS and the User 
        and ARUN PLUS shall not be held liable for any action by the User except 
        as stated in the Terms. If there is any claim made by a third party 
        against ARUN PLUS due to the User, the User shall be the sole liable party.  
        </DefaultParagraph>

        <DefaultTitle>11.Governing Law</DefaultTitle>
        <DefaultParagraph>
        The Terms shall be governed by and interpreted in accordance with the laws of Thailand.
        </DefaultParagraph>

        <DefaultTitle>12.News, Notification, and Communication</DefaultTitle>
        <DefaultParagraph leader="12.1">
        For the benefit of the User, ARUN PLUS may send news communication 
        such as Information about EV Chargers and Services, marketing Information, 
        and sale promotion, among others, to various electronic addresses of the User, 
        such as on the Application, the website, email, and telephone number, 
        among others. The User may cancel or decline to receive such communication 
        by clicking this link provided by ARUN PLUS.
        </DefaultParagraph>
        <DefaultParagraph leader="12.2">
        Any communication, document, writing, or Information sent by ARUN PLUS to the User at the address, 
        telephone number, or email provided to ARUN PLUS by the User, 
        or the amendment of which ARUN PLUS has been notified, via postal service, 
        text messaging, email, or any other electronic communication (if any), 
        shall be deemed to have been duly sent to the User and the User shall be deemed 
        to have acknowledged the receipt of such communication, document, writing, or Information.
        </DefaultParagraph>
        <DefaultParagraph leader="12.2" hideleader>
        Any communication, document, writing, or Information that ARUN PLUS receives from the 
        User or the User's designated contact person, shall be deemed to be the User's true, 
        accurate, and deliberate communication, document, writing, or Information and shall be binding upon the User.
        </DefaultParagraph>
      </div>
    </div>
  );
};

export default TermsEnglish;
